// Packages
import cn from 'classnames';
// Components
import Skeleton, { SkeletonBlock } from './Skeleton';
// Styles
import styles from './inputSkeleton.module.scss';

interface IInputSkeletonProps {
  size?: 'small' | 'middle' | 'large';
}

/** A field-shaped placeholder, the height of the lib's inputs, for a field whose code is still loading. */
const InputSkeleton = ({ size = 'middle' }: IInputSkeletonProps) => (
  <Skeleton>
    <SkeletonBlock className={cn(styles.input, styles[size])} />
  </Skeleton>
);

export default InputSkeleton;
